const NATIONAL_LENGTH = 10;
const DEFAULT_LADA = '+52';

export interface PhoneParts {
    lada: string;
    number: string;
}

export const splitPhoneLada = (value?: string | null): PhoneParts => {
    const digits = (value ?? '').replace(/\D/g, '');

    if (digits === '') {
        return { lada: DEFAULT_LADA, number: '' };
    }

    if (digits.length <= NATIONAL_LENGTH) {
        return { lada: DEFAULT_LADA, number: digits };
    }

    return {
        lada: `+${digits.slice(0, digits.length - NATIONAL_LENGTH)}`,
        number: digits.slice(-NATIONAL_LENGTH),
    };
};

export const joinPhoneLada = (
    lada?: string | null,
    phone?: string | null,
): string => {
    const number = (phone ?? '').replace(/\D/g, '');

    if (number === '') {
        return '';
    }

    const code = (lada ?? '').replace(/\D/g, '');

    return code === '' ? number : `+${code} ${number}`;
};
